import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiError } from "@/lib/api";
import { Wordmark } from "@/components/site/Navbar";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-cream px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-[2rem] border border-olive/10 bg-white p-10 shadow-[0_20px_60px_-30px_rgba(43,51,43,0.25)]">
        <Wordmark />
        <h1 className="mt-8 font-serif text-3xl text-ink">Admin sign in</h1>
        <p className="mt-2 text-sm text-olive/60">Homevia team access only.</p>
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label htmlFor="admin-email">Email</Label>
            <Input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 rounded-xl border-olive/15 bg-cream/60"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password">Password</Label>
            <Input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 rounded-xl border-olive/15 bg-cream/60"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="rounded-xl bg-destructive/10 px-4 py-3 text-sm text-destructive">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit-btn"
            disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-teal-deep px-8 py-3.5 text-sm font-bold text-cream transition-colors hover:bg-olive disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign In
          </button>
        </form>
        <Link to="/" data-testid="admin-back-to-site-link" className="mt-6 block text-center text-sm text-teal-deep hover:underline">
          Back to Homevia website
        </Link>
      </div>
    </div>
  );
}
